const strUserProgramRoles = (user) => {
    let pRoles = []
    if( user?.roles )    {
        for( var i in user.roles) {
            pRoles.push(user.roles[i].name)
        }
    }
    if( user.isAdmin ) pRoles.push("Admin")
    // Dedupe: with search_in_all, roles are loaded across every matched
    // program, so the same role name (e.g. "Manager") repeats once per
    // program the user holds it in — which program is shown separately
    // in the Programs column, so role names only need to appear once here.
    pRoles = [...new Set(pRoles)]
    return pRoles.join(", ") || 'NA'
}
export const USERS_COLUMNS = [
    {
        Header: "ID",
        accessor: "id",
        width: 70,
    },
    {
        Header: "Name",
        accessor: "name",
    },
    {
        Header: "Email",
        accessor: "email",
        width: 220
    },
    {
        Header: "Program Roles",
        accessor: "role_id",
        Cell: ({ row, value }) => { return strUserProgramRoles(row.original)},
    },
    {
        Header: "Status",
        accessor: "user_status_id",
        width: 90,
    },
    {
        Header: "Default Contact",
        width: 65
    }
]

// With All Programs search, a row can belong only to a sub-program — program-scoped
// actions (Edit/Unassign/Move) act against the currently selected program's id, so
// running them on such a row would silently no-op against a program the user was
// never assigned to (ICOV3-1663).
export const isRowOutsideCurrentProgram = (rowPrograms, currentProgramId, searchInAll) => {
    if (!searchInAll) return false;
    const programs = rowPrograms || [];
    if (!programs.length) return false;
    return !programs.some(p => p.id === currentProgramId);
}

export const getManagerColumns = (options = {}) => {
    const { searchInAll = false } = options;
    return [
        ...USERS_COLUMNS,
        ...(searchInAll ? [
            {
                Header: "Programs",
                accessor: "programs",
                minWidth: 200,
                width: 200,
                maxWidth: 250,
                Cell: ({ row }) => {
                    const programs = row.original.programs || [];
                    const fullNames = programs.map(p => p.name).filter(Boolean).join(', ');
                    const display = fullNames.length > 30 ? fullNames.slice(0, 30) + '…' : fullNames;
                    return (
                        <div className="hover-item addresses" style={{ cursor: 'default' }} data-tip={fullNames || undefined}>
                            {display || '—'}
                        </div>
                    );
                },
            },
        ] : []),
    ]
}